import React from 'react';
import QuickviewImageLoadingComponent from '../../pages/Quickview/QuickviewLoading/QuickviewImageLoadingComponent';

function AltImageSkeletonLoading({
  hasFitInfo, totalImages, isMobile, isBrowser,
}) {
  const containerClass = `${isMobile && hasFitInfo ? 'has-model-measurement' : ''} ${!isMobile ? 'quickview-image-container-loading' : ''} ${isMobile ? 'quickview-mobile-loading' : ''}`;
  const variant = isMobile ? 'mobileImage' : '';

  return (
    <div className={containerClass}>
      <QuickviewImageLoadingComponent variant={variant} />
      {(isMobile || isBrowser) && hasFitInfo && (
        <div className="model-measurements-loading-container">
          <div className="model-measurements-loading" />
        </div>
      )}
      {isMobile && totalImages > 1 && <QuickviewImageLoadingComponent variant="mobileThumbnails" />}
    </div>
  );
}

export default AltImageSkeletonLoading;
